import { Router } from '@angular/router';
import { DetailModes } from './../shared/constants';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { TranslocoService } from '@ngneat/transloco';
import { HelperService } from '../services/helper.service';

export class BaseDetail {

  public loading = false;
  public viewMode: DetailModes | null = null;
  public viewModes = DetailModes;
  public messages: Array<any> = [];
  public inEdit: string = null;
  public tabIndex = 0;
  public backRoute: Array<any> | null = null;

  protected identifier = 'basedetail';

  constructor(
    protected ui: UiService,
    protected router: Router,
    protected helper: HelperService,
    protected transloco: TranslocoService,
  ) { }

  onTabChange(event: any): void {
    localStorage.setItem(this.identifier + '-tab', event.index);
    this.ui.setFocus();
  }

  setEdit(tab: string = null): void {
    this.inEdit = tab;
  }

  isDisabled(tab: string): boolean {
    return this.inEdit !== null && this.inEdit !== tab;
  }

  newMode(): boolean {
    return this.viewMode === DetailModes.new;
  }

  editMode(): boolean {
    return this.viewMode === DetailModes.edit;
  }

  onClose(): void {
    if (this.backRoute !== null) {
      this.router.navigate(this.backRoute);
    }
  }

  protected setLoading(): void {
    this.loading = true;
  }

  protected setInitialized(viewMode: DetailModes = null): void {
    this.loading = false;
    this.viewMode = viewMode;
  }

  protected setFailed(error: any, route: string = null): void {
    this.loading = false;
    if (this.helper.isAuthorized(error.status) === false) {
      if (error.status === 403) {
        this.ui.toastError(
          this.transloco.translate('backend.exceptions.not_authorized'),
          this.transloco.translate('common.error'),
          8000
        );
      }
      this.router.navigate((route !== null) ? [route] : this.backRoute || ['dashboard']);
    }
  }

}
